document.addEventListener("DOMContentLoaded", function(event) {
  var links = document.querySelectorAll(".header-mutual .group-link");
  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      document.getElementById('toggle-menu-mobile').click();
    });
  });
});
